import { render, staticRenderFns } from "./ZalogaItem.vue?vue&type=template&id=597769f6&"
import script from "./ZalogaItem.vue?vue&type=script&lang=js&"
export * from "./ZalogaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports